import displayError from '@/api/errors/errorResponse'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/forms/form/Form'
import { Button } from '@/components/ui/common/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog/Dialog'
import { useMutation } from '@tanstack/react-query'

import { editAdvertisementJobService } from '@/api/services/advertisements/advertisementsService'
import FormWrap from '@/components/forms/form/FormWrap'
import { Input } from '@/components/forms/inputs/text/Input'
import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const inputSchema = z.object({
  prompt: z.string().min(1, 'Wartość jest wymagana')
})

type InputSchema = z.infer<typeof inputSchema>

function EditGenerator({
  id,
  setResultIds
}: {
  id: string
  setResultIds: (ids: string[]) => void
}) {
  const [open, setOpen] = useState(false)
  const form = useForm<InputSchema>({
    resolver: zodResolver(inputSchema),
    defaultValues: {
      prompt: ''
    }
  })

  const { mutate, isPending } = useMutation({
    mutationFn: (body: InputSchema) => editAdvertisementJobService(id, body),
    onSuccess: (res) => {
      if (!res.success) return displayError(res)
      setOpen(false)
      setResultIds([res.data.id])
      form.reset()
    }
  })

  const onSubmit = (data: InputSchema) => {
    mutate(data)
  }

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>
        <Button>Edytuj</Button>
      </DialogTrigger>
      <DialogContent aria-describedby="Edytuj grafikę" aria-description="Edytuj grafikę">
        <DialogHeader>
          <DialogTitle>Edycja grafiki</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <FormWrap onSubmit={form.handleSubmit(onSubmit)}>
            <FormField
              control={form.control}
              name="prompt"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Opisz instrukcję</FormLabel>
                  <FormControl>
                    <Input placeholder="Wpisz instrukcję edycji grafiki..." {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="mt-4 -mb-6 flex items-center justify-end">
              <Button disabled={isPending} type="submit">
                Edycja grafiki
              </Button>
            </div>
          </FormWrap>
        </Form>
      </DialogContent>
    </Dialog>
  )
}

export default EditGenerator
